import type { LocationQuery } from "vue-router";

/**
 * IEC 61406-2 §5.7.2: a query parameter starting with "." (e.g. ".1P", ".1T") marks a structured identification link.
 */
export function isIdLinkQuery(query: LocationQuery): boolean {
    return Object.keys(query).some((key) => key.startsWith("."));
}

/**
 * Passes the identification link parameters through to the anonymous resolver endpoint.
 * Keys are upper-cased because ISO/IEC 15418 data identifiers are upper-case (".1t" → ".1T").
 */
export function idLinkWorkspaceUrl(query: LocationQuery): string {
    const params = new URLSearchParams();
    for (const [key, value] of Object.entries(query)) {
        for (const item of [value].flat()) {
            if (item !== null) {
                params.append(key.toUpperCase(), item);
            }
        }
    }

    return `/api/domain/id-link/workspace?${params}`;
}
